import React, { useEffect } from 'react'

import AOS from 'aos';
import 'aos/dist/aos.css';
const data = [
  {
    id: 1,
    label: 'Research Framework',
    title: 'Structure',
    desc: 'Qlab studies financial markets as complex adaptive systems and analyzes how behavior, liquidity, and volatility interact across asset classes and time horizons.'
  }, {
    id: 2,
    label: 'Model Development',
    title: 'Systematic Modeling',
    desc: 'Our research process develops systematic quantitative models to detect structural inefficiencies with disciplined experimentation and robust validation workflows.'
  },
  {
    id: 3,
    label: 'Signal Extraction',
    title: 'Statistical Edge',
    desc: 'Rather than relying on discretionary decisions, we build rule-based systems designed to isolate repeatable statistical signals under realistic market conditions.'
  },
  {
    id: 4,
    label: 'Risk Management',
    title: 'Risk Discipline',
    desc: 'Every model is evaluated through risk-aware controls focused on stability, drawdown behavior, and consistency across changing market regimes.'
  },
]

const principles = [
  {
    number: '01',
    title: 'Evidence Over Opinion',
    desc: 'All strategies must be supported by statistically significant empirical evidence.'
  },
  {
    number: '02',
    title: 'Reproducibility',
    desc: 'Research must be fully reproducible using deterministic data pipelines and versioned datasets.'
  },
  {
    number: '03',
    title: 'Risk First',
    desc: 'Strategy design begins with risk constraints and portfolio impact rather than return optimization.'
  },
  {
    number: '04',
    title: 'Out-of-Sample Validation',
    desc: 'All signals must demonstrate robustness outside the discovery sample before deployment.'
  },
  {
    number: '05',
    title: 'Systematic Execution',
    desc: 'Models are deployed exclusively through automated execution frameworks.'
  }
]

const data2 = [
  {
    id: 1,
    desc: 'At Qlab, we approach markets as complex adaptive systems and investigate how structural behavior evolves across global financial environments.'
  },
  {
    id: 2,
    desc: 'Our research is centered on developing quantitative frameworks that identify inefficiencies across asset classes using systematic experimentation and rigorous statistical analysis.'
  },
]
const WhoWeAre = () => {
  useEffect(() => {
    AOS.init({
      // Global settings here...
    });
  }, []);

  return (
    <section id='research' className='research-dark-section py-32 lg:py-36 xl:py-40 px-5 md:px-8 flex flex-col justify-center items-center'>
      <div className='w-full max-w-[1100px]'>
        <h1 className='section-label metro-semi mb-6' data-aos="fade-up" data-aos-duration="1000">Research Philosophy</h1>
        <h1 data-aos="fade-up" data-aos-duration="1000" className='main-headline section-headline domin mb-10 lg:mb-12'>Qlab develops systematic research models to detect structural inefficiencies across asset classes.</h1>
        {data2.map((item) => (
          <p data-aos="fade-up" data-aos-duration="1000" className='text-[19px] lg:text-[22px] xl:text-[24px] text-secondary-light metro leading-relaxed mb-6 lg:mb-8' key={item.id}>{item.desc}</p>
        ))}
      </div>

      <div className='w-full max-w-[1100px] mt-24 lg:mt-28'>
        <hr className='divider mb-16 border-0 h-[1px] bg-[#eeeeee]' />
        <h2 data-aos="fade-up" data-aos-duration="1000" className='section-label metro-semi mb-8'>Research Principles</h2>
        <div className='research-principles-list border-y border-black/10'>
          {principles.map((principle) => (
            <div data-aos="fade-up" data-aos-duration="1000" key={principle.number} className='research-principle-row divider'>
              <div className='research-principle-number principle-number'>{principle.number}</div>
              <div>
                <h3 className='research-principle-title principle-title'>{principle.title}</h3>
                <p className='research-principle-desc principle-text'>{principle.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className='research-grid grid grid-cols-1 lg:grid-cols-2 w-full max-w-[1100px] gap-x-8'>
        {data.map((item, id) => (
          <div data-aos="fade-up" data-aos-duration="1000" className='research-item card flex flex-col' key={item.id}>
            <h1 className='research-title card-title mb-3 h-fit flex items-center metro-semi'>
              <span className='research-number'>{id + 1}</span>
              <span>
                <span className='section-label card-subtitle'>{item.label}</span>
                {item.title}
              </span>
            </h1>
            <p className='research-description card-text h-fit metro'>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default WhoWeAre
